import { create } from 'zustand';

interface IDemoMode {
  isDemoMode: boolean;
  setIsDemoMode: (value: boolean) => void;
}

export const useDemoModeStore = create<IDemoMode>((set) => ({
  isDemoMode: false,
  setIsDemoMode: (value) => set({ isDemoMode: value }),
}));
